import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { API } from "../context/AppContext";
import ImageOrArt from "../components/ImageOrArt";
import { Reveal } from "../components/Reveal";

export default function ArtworkDetail() {
  const { id } = useParams();
  const [art, setArt] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API}/artworks/${id}`).then(({ data }) => setArt(data)).catch(() => setError(true));
  }, [id]);

  if (error)
    return (
      <main className="pt-40 container-x" data-testid="artwork-not-found">
        <p className="text-muted-foreground">Artwork not found.</p>
        <Link to="/artwork" className="btn-ghost mt-6">Back to Gallery</Link>
      </main>
    );
  if (!art) return <main className="pt-40 container-x" data-testid="artwork-loading"><p className="font-mono-x text-sm text-muted-foreground">Loading…</p></main>;

  const meta = [
    ["Year", art.year],
    ["Medium", art.medium],
    ["Dimensions", art.dimensions],
    ["Category", art.category],
    ["Availability", art.availability],
  ];

  return (
    <main className="pt-24 sm:pt-32" data-testid="artwork-detail-page">
      <section className="container-x section-y">
        <Link to="/artwork" className="inline-flex items-center gap-2 text-xs font-display font-bold uppercase tracking-widest text-muted-foreground hover:text-[#FF1A1A] transition-colors mb-10" data-testid="back-to-gallery">
          <ArrowLeft size={14} /> Back to Gallery
        </Link>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <Reveal>
            <div className="border border-border p-3 sm:p-4">
              <ImageOrArt image={art.image} seed={art.seed} className="w-full" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div>
              <p className="eyebrow mb-4">{art.category}</p>
              <h1 className="h-section mb-4" data-testid="artwork-detail-title">{art.title}</h1>
              <p className="text-muted-foreground mb-8 max-w-md">{art.blurb}</p>
              <dl className="border-t border-border mb-8" data-testid="artwork-meta">
                {meta.map(([k, v]) => (
                  <div key={k} className="flex justify-between py-3 border-b border-border text-sm">
                    <dt className="font-mono-x text-xs uppercase tracking-widest text-muted-foreground">{k}</dt>
                    <dd className="font-medium text-right">{v}</dd>
                  </div>
                ))}
                <div className="flex justify-between py-3 border-b border-border text-sm">
                  <dt className="font-mono-x text-xs uppercase tracking-widest text-muted-foreground">Price</dt>
                  <dd className="font-display font-bold text-[#FF1A1A]" data-testid="artwork-price">{art.price > 0 ? `$${art.price.toLocaleString()}` : "Price on request"}</dd>
                </div>
              </dl>
              <Link
                to={`/contact?category=Artwork Inquiry&piece=${encodeURIComponent(art.title)}`}
                className="btn-red"
                data-testid="artwork-inquiry-button"
              >
                Inquire About This Work
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
